/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrariPianificazioneResDto } from '../../models/orari-pianificazione-res-dto';

export interface OrariPianificazioniControllerDeleteOrarioPianificazione$Params {
  idPianificazione: number;
}

export function orariPianificazioniControllerDeleteOrarioPianificazione(
  http: HttpClient,
  rootUrl: string,
  params: OrariPianificazioniControllerDeleteOrarioPianificazione$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<OrariPianificazioneResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    orariPianificazioniControllerDeleteOrarioPianificazione.PATH,
    'delete',
  );
  if (params) {
    rb.path('idPianificazione', params.idPianificazione, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OrariPianificazioneResDto>;
      }),
    );
}

orariPianificazioniControllerDeleteOrarioPianificazione.PATH =
  '/admin/orarioPianificazione/id/{idOrarioPianificazione}';
